var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 3.33333C8.96513 3.33333 8.66667 3.03485 8.66667 2.66667C8.66667 2.29848 8.96513 2 9.33333 2H13.3333C13.5101 2 13.6797 2.07024 13.8047 2.19526C13.9297 2.32029 14 2.48985 14 2.66667V6.66667C14 7.03487 13.7015 7.33333 13.3333 7.33333C12.9651 7.33333 12.6667 7.03487 12.6667 6.66667V4.27615L6.47141 10.4714C6.21105 10.7317 5.78895 10.7317 5.52859 10.4714C5.26825 10.2111 5.26825 9.78893 5.52859 9.5286L11.7239 3.33333H9.33333ZM2 4.66667C2 3.93029 2.59695 3.33333 3.33333 3.33333H6.66667C7.03487 3.33333 7.33333 3.63181 7.33333 4C7.33333 4.36819 7.03487 4.66667 6.66667 4.66667H3.33333V12.6667H11.3333V9.33333C11.3333 8.96513 11.6318 8.66667 12 8.66667C12.3682 8.66667 12.6667 8.96513 12.6667 9.33333V12.6667C12.6667 13.4031 12.0697 14 11.3333 14H3.33333C2.59695 14 2 13.4031 2 12.6667V4.66667Z",
    fill: "#1B8C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon3);
export default __webpack_public_path__ + "static/media/external-link-icon-3.9e2794a5eaa5701c3185ee252553a41f.svg";
export { ForwardRef as ReactComponent };